export default [
  // 电子码单(仓库销售单)
  {
    path: '/common/order-code/base',
    name: 'CommonOrderCodeBase',
    component: () => import(/* webpackChunkName: 'CommonOrderCodeBase' */ '@/views/common/order-code/base'),
  },
  // 打开CRM
  {
    path: '/openapp',
    name: 'openApp',
    component: () => import(/* webpackChunkName: 'openApp' */ '@/views/openApp/index.vue'),
  },
  // 积分规则；
  {
    path: '/common/integral-rules',
    name: 'CommonIntegralRules',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/common/integral-rules'),
  },
];
